"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEventProfileStencil = exports.eventProfileStencilDefinition = void 0;
const properties_1 = require("../properties");
const wrcErcContentAreas = [
    {
        name: 'main',
        items: [
            'quick-event',
            'header-media',
            'title',
            'subheading',
            'teaser',
            'description',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'label',
                    'seo-title',
                    'social-title',
                    'featured-title',
                    'uri-title',
                    'url',
                    'event-start-date',
                    'event-end-date',
                    'event-status',
                    'event-status-message',
                    'hosted-by-red-bull',
                    'featured-media',
                    'social-media-image',
                    'featured-video',
                    'live-videos',
                    'geolocation',
                    'event-season',
                    'series',
                    'logos',
                ],
            },
            {
                name: 'CTA',
                items: ['cta-container'],
            },
            {
                name: 'Social links',
                items: [
                    'social-links',
                    'social-wall',
                    'website',
                ],
            },
            {
                name: 'Partners',
                items: [
                    'partner-profiles',
                    'main-partner-caption',
                    'main-partner-asset',
                ],
            },
            {
                name: 'Subpages',
                items: ['subpages-container'],
            },
            {
                name: 'Results',
                items: ['event-results'],
            },
            {
                name: 'Settings',
                items: [
                    'search-terms',
                    'standalone',
                    'no-monetization',
                    'sponsored-by',
                ],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'disciplines',
            'content-categories',
            'tag-events',
            'tag-event-series',
            'tag-rally-drivers',
            'tag-rally-teams',
            'related-content',
        ],
    },
];
exports.eventProfileStencilDefinition = {
    view: {
        label: 'Event profile',
        category: 'event',
        group: 'Events & Projects',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'quick-event',
                    'header-media',
                    'title',
                    'subheading',
                    'teaser',
                    'description',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'label',
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'uri-title',
                            'url',
                            'event-start-date',
                            'event-end-date',
                            'event-status',
                            'event-status-message',
                            'hosted-by-red-bull',
                            'featured-media',
                            'social-media-image',
                            'featured-video',
                            'live-videos',
                            'geolocation',
                            'event-season',
                            'series',
                            'logos',
                        ],
                    },
                    {
                        name: 'CTA',
                        items: ['cta-container'],
                    },
                    {
                        name: 'Social links',
                        items: [
                            'social-links',
                            'social-wall',
                            'website',
                        ],
                    },
                    {
                        name: 'Partners',
                        items: [
                            'partner-profiles',
                            'main-partner-caption',
                            'main-partner-asset',
                        ],
                    },
                    {
                        name: 'Subpages',
                        items: ['subpages-container'],
                    },
                    {
                        name: 'Results',
                        items: ['event-results'],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'standalone',
                            'no-monetization',
                            'sponsored-by',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-photographers',
                    'tag-judges',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
        previewConfiguration: {
            hasPagePreview: true,
            hasFeatureCardPreview: true,
        },
    },
    content: {
        'content-categories': {
            ...properties_1.contentCategoriesPropertyDefinition,
            view: {
                ...properties_1.contentCategoriesPropertyDefinition.view,
                hidable: true,
            },
        },
        'cta-container': properties_1.ctaContainerPropertyDefinition,
        description: {
            ...properties_1.descriptionPropertyDefinition,
            view: {
                ...properties_1.descriptionPropertyDefinition.view,
                hidable: true,
            },
        },
        disciplines: {
            ...properties_1.disciplinesPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: ['discipline'],
                },
            ],
        },
        'event-end-date': properties_1.eventEndDatePropertyDefinition,
        'event-results': {
            ...properties_1.eventResultsPropertyDefinition,
            view: {
                ...properties_1.eventResultsPropertyDefinition.view,
                hidable: true,
            },
        },
        'event-season': properties_1.eventSeasonPropertyDefinition,
        'event-start-date': properties_1.eventStartDatePropertyDefinition,
        'event-status': properties_1.eventStatusPropertyDefinition,
        'event-status-message': {
            ...properties_1.eventStatusMessagePropertyDefinition,
            view: {
                ...properties_1.eventStatusMessagePropertyDefinition.view,
                hidable: true,
            },
        },
        'featured-media': properties_1.featuredMediaPropertyDefinition,
        'featured-title': {
            ...properties_1.featuredTitlePropertyDefinition,
            view: {
                ...properties_1.featuredTitlePropertyDefinition.view,
                hidable: true,
            },
        },
        'featured-video': {
            ...properties_1.featuredVideoPropertyDefinition,
            view: {
                ...properties_1.featuredVideoPropertyDefinition.view,
                hidable: true,
            },
        },
        geolocation: properties_1.geolocationPropertyDefinition,
        'header-media': {
            ...properties_1.headerMediaPropertyDefinition,
            view: {
                ...properties_1.headerMediaPropertyDefinition.view,
                hidable: true,
            },
        },
        'hosted-by-red-bull': properties_1.hostedByRedBullPropertyDefinition,
        label: {
            ...properties_1.labelPropertyDefinition,
            constraints: [
                {
                    name: 'maxLength',
                    argument: 45,
                },
            ],
            view: {
                ...properties_1.labelPropertyDefinition.view,
                hidable: true,
            },
        },
        'live-videos': {
            ...properties_1.liveVideosPropertyDefinition,
            view: {
                ...properties_1.liveVideosPropertyDefinition.view,
                hidable: true,
            },
        },
        logos: properties_1.logosPropertyDefinition,
        'main-partner-asset': {
            ...properties_1.mainPartnerAssetPropertyDefinition,
            view: {
                ...properties_1.mainPartnerAssetPropertyDefinition.view,
                hidable: true,
            },
        },
        'main-partner-caption': {
            ...properties_1.mainPartnerCaptionPropertyDefinition,
            view: {
                ...properties_1.mainPartnerCaptionPropertyDefinition.view,
                hidable: true,
            },
        },
        'no-monetization': {
            ...properties_1.noMonetizationPropertyDefinition,
            view: {
                ...properties_1.noMonetizationPropertyDefinition.view,
                hidable: true,
            },
        },
        'partner-profiles': {
            ...properties_1.partnerProfilesPropertyDefinition,
            view: {
                ...properties_1.partnerProfilesPropertyDefinition.view,
                hidable: true,
            },
        },
        'properties-container': {
            ...properties_1.propertiesContainerPropertyDefinition,
            view: {
                ...properties_1.propertiesContainerPropertyDefinition.view,
                hidable: true,
            },
        },
        'quick-event': properties_1.quickEventPropertyDefinition,
        'related-content': {
            ...properties_1.relatedContentPropertyDefinition,
            view: {
                ...properties_1.relatedContentPropertyDefinition.view,
                hidable: true,
            },
        },
        'search-terms': {
            ...properties_1.searchTermsPropertyDefinition,
            view: {
                ...properties_1.searchTermsPropertyDefinition.view,
                hidable: true,
            },
        },
        'seo-title': {
            ...properties_1.seoTitlePropertyDefinition,
            view: {
                ...properties_1.seoTitlePropertyDefinition.view,
                hidable: true,
            },
        },
        series: properties_1.seriesPropertyDefinition,
        'social-links': {
            ...properties_1.socialLinksPropertyDefinition,
            view: {
                ...properties_1.socialLinksPropertyDefinition.view,
                hidable: true,
            },
        },
        'social-media-image': {
            ...properties_1.socialMediaImagePropertyDefinition,
            view: {
                ...properties_1.socialMediaImagePropertyDefinition.view,
                hidable: true,
            },
        },
        'social-title': {
            ...properties_1.socialTitlePropertyDefinition,
            view: {
                ...properties_1.socialTitlePropertyDefinition.view,
                hidable: true,
            },
        },
        'social-wall': {
            ...properties_1.socialWallPropertyDefinition,
            view: {
                ...properties_1.socialWallPropertyDefinition.view,
                hidable: true,
            },
        },
        'sponsored-by': {
            ...properties_1.sponsoredByPropertyDefinition,
            view: {
                ...properties_1.sponsoredByPropertyDefinition.view,
                hidable: true,
            },
        },
        standalone: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        subheading: properties_1.subheadingPropertyDefinition,
        'subpages-container': {
            ...properties_1.subpagesContainerPropertyDefinition,
            view: {
                ...properties_1.subpagesContainerPropertyDefinition.view,
                hidable: true,
            },
        },
        'tag-event-series': {
            ...properties_1.tagEventSeriesPropertyDefinition,
            view: {
                ...properties_1.tagEventSeriesPropertyDefinition.view,
                hidable: true,
            },
        },
        'tag-events': {
            ...properties_1.tagEventsPropertyDefinition,
            view: {
                ...properties_1.tagEventsPropertyDefinition.view,
                hidable: true,
            },
        },
        'tag-judges': {
            ...properties_1.tagJudgesPropertyDefinition,
            view: {
                ...properties_1.tagJudgesPropertyDefinition.view,
                hidable: true,
            },
        },
        'tag-persons': {
            ...properties_1.tagPersonsPropertyDefinition,
            view: {
                ...properties_1.tagPersonsPropertyDefinition.view,
                hidable: true,
            },
        },
        'tag-photographers': {
            ...properties_1.tagPhotographersPropertyDefinition,
            view: {
                ...properties_1.tagPhotographersPropertyDefinition.view,
                hidable: true,
            },
        },
        'tag-rally-drivers': properties_1.tagRallyDriversPropertyDefinition,
        'tag-rally-teams': properties_1.tagRallyTeamsPropertyDefinition,
        'tag-teams': {
            ...properties_1.tagTeamsPropertyDefinition,
            view: {
                ...properties_1.tagTeamsPropertyDefinition.view,
                hidable: true,
            },
        },
        teaser: {
            ...properties_1.teaserPropertyDefinition,
            view: {
                ...properties_1.teaserPropertyDefinition.view,
                hidable: true,
            },
        },
        title: {
            ...properties_1.titlePropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'maxLength',
                    argument: 75,
                },
            ],
        },
        'uri-title': properties_1.uriTitlePropertyDefinition,
        url: {
            ...properties_1.urlPropertyDefinition,
            view: {
                ...properties_1.urlPropertyDefinition.view,
                hidable: true,
            },
        },
        website: {
            ...properties_1.websitePropertyDefinition,
            view: {
                ...properties_1.websitePropertyDefinition.view,
                hidable: true,
            },
        },
    },
    localizations: [],
    roles: [],
    spaces: [
        'alinghi',
        'batalla',
        'brand-building-events',
        'erc',
        'global',
        'illume',
        'media-partnerships',
        'pro-cycling',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'rbtv',
        'rbtv_temporary',
        'redbull_com',
        'redbull-advancedtechnologies',
        'redbull-f1academy',
        'redbull-powertrains',
        'redbull-racing',
        'redbull-simracing',
        'redbulletin',
        'wingfinder',
        'wrc',
    ],
    name: 'event-profile',
    overwrites: [
        {
            condition: 'space',
            argument: 'erc',
            contentAreas: wrcErcContentAreas,
        },
        {
            condition: 'space',
            argument: 'wrc',
            contentAreas: wrcErcContentAreas,
        },
    ],
};
const isEventProfileStencil = (stencil) => {
    return stencil.name === exports.eventProfileStencilDefinition.name;
};
exports.isEventProfileStencil = isEventProfileStencil;
//# sourceMappingURL=data:application/json;base64,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